import { isBrowser } from './check';
const URL_PREFIX_PATH = process.env.REACT_APP_URL_PREFIX_PATH;
const URL_PREFIX_DOMAIN = process.env.REACT_APP_URL_PREFIX_DOMAIN;

const getPrefix = () => {
  if (URL_PREFIX_PATH?.indexOf('/') > -1) {
    throw new Error('The urlPrefixPath cannot have a slash!');
  }

  return isBrowser() && window.location.hostname.indexOf(URL_PREFIX_DOMAIN) > -1
    ? `/${URL_PREFIX_PATH}`
    : '';
};

export { getPrefix };
